import { COLOR, STATUS } from "./actionTypes";

export const status = (status) => {
  return {
    type: STATUS,
    payload: status,
  };
};
export const color = (color, changeType) => {
  return {
    type: COLOR,
    payload: {
      color,
      changeType,
    },
  };
};
